import { Dispatch } from 'redux';

import { resetNewNavigation } from '@app/services/new-navigation';
import { cleanupWebSocketSingletons } from '@app/services/websocket';
import { resetAuthLoaderFlags } from '@app/utils/auth-loader-prefetch';

import { DEAUTH_USER } from '../constants/actions';

/**
 * Deauth user and unsubscribe from all topics.
 * This should be used instead of directly dispatching DEAUTH_USER.
 *
 * @returns {function(Dispatch): void} A higher-order function that takes a Redux dispatch
 * function and performs the deauthentication and cleanup.
 * @param {Dispatch} dispatch - The Redux dispatch function used to dispatch actions to the store.
 */
export const deauthUserAndUnsubscribeTopics = () => (dispatch: Dispatch) => {
  // Centralized websocket cleanup through socket service
  cleanupWebSocketSingletons();

  // Reset data fetch flags to ensure fresh data on next login
  resetAuthLoaderFlags();

  resetNewNavigation();

  // // Dispatch DEAUTH_USER without payload (reducers don't use payload)
  dispatch({ type: DEAUTH_USER });
};

export default deauthUserAndUnsubscribeTopics;
